// Le cabinet se lit dans l'adresse : `dupont.delo.altekk.tech` → `dupont`.
//
// C'est le serveur qui tranche (il relit le nom d'hôte de la requête) ; le
// client ne fait que s'aligner, pour savoir s'il doit encore demander le
// cabinet à l'utilisateur.

/** Domaine public de l'app. Le sous-domaine qui le précède désigne le cabinet. */
const PUBLIC_DOMAIN = import.meta.env.VITE_PUBLIC_DOMAIN ?? '';

/**
 * Slug du cabinet déduit de l'adresse, ou `null` en développement (on tape sur
 * `localhost`, il n'y a pas de sous-domaine à lire).
 */
export function tenantFromHost(): string | null {
  if (!PUBLIC_DOMAIN) return null;

  const host = window.location.hostname.toLowerCase();
  const suffix = `.${PUBLIC_DOMAIN.toLowerCase()}`;
  if (!host.endsWith(suffix)) return null;

  const slug = host.slice(0, -suffix.length);
  // Un seul niveau : `a.b.delo.altekk.tech` n'est pas un cabinet.
  if (!slug || slug.includes('.')) return null;
  return slug;
}
